import React from 'react'
import { twMerge } from 'tailwind-merge'

export interface ButtonLikeLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ButtonLikeLink = ({ children, className, disabled, ...rest }: ButtonLikeLinkProps) => {
  return (
    <button
      {...rest}
      className={twMerge(
        'text-brand-primary main-transition [&>svg>path]:transition-all [&>svg>path]:fill-brand-primary flex items-center',
        '[&:hover]:text-text-secondary [&:hover>svg>path]:fill-text-secondary',
        disabled && 'text-text-secondary [&>svg>path]:fill-text-secondary',
        className,
      )}
    >
      {children}
    </button>
  )
}

export default ButtonLikeLink
